// extracted by mini-css-extract-plugin
export var arrowContainer = "ImageGridContainer-module--arrow-container--433af";
export var arrowContainerRight = "ImageGridContainer-module--arrow-container-right--8e329";
export var displayNavigation = "ImageGridContainer-module--display-navigation--6a996";
export var imgContainer = "ImageGridContainer-module--img-container--fabc8";
export var nextButton = "ImageGridContainer-module--next-button--42706";
export var prevButton = "ImageGridContainer-module--prev-button--ddf54";
export var prodImg = "ImageGridContainer-module--prod-img--a925d";
export var swiperContainer = "ImageGridContainer-module--swiper-container--4de33";